import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Card, Image, Typography, Spin, Alert, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import config from '../../../config';

const { Title, Text } = Typography;

const VarianteEdit = ({ id, closeModal }) => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchVariant = async () => {
            try {
                const { data } = await axios.get(`${DOMAIN}/api/produit/varianteDetail/${id}`);
                setData(data[0]);
            } catch (error) {
                // silently ignore — loading spinner stays
            } finally {
                setLoading(false);
            }
        };
        fetchVariant();
    }, [id, DOMAIN]);

    const handleGoToReconciliation = () => {
        closeModal();
        navigate('/reconciliation_stocks');
    };

    if (loading) {
        return (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>
        );
    }

    if (!data) return null;

    return (
        <Card
            title={<Title level={3}>{data.nom_produit}</Title>}
            bordered={false}
            style={{ maxWidth: 500, margin: '0 auto', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}
        >
            <Image
                src={`${DOMAIN}${data.img}`}
                alt={data.nom_produit}
                style={{ borderRadius: 8 }}
                width={200}
                height={200}
                preview={false}
            />
            <div style={{ padding: '20px 0' }}>
                <Text strong>Marque :</Text> <Text>{data.nom_marque}</Text>
                <br />
                <Text strong>Pointure :</Text> <Text>{data.pointure}</Text>
                <br />
                <Text strong>Stock comptable actuel :</Text>{' '}
                <Text strong style={{ fontSize: '1.1rem' }}>{data.stock}</Text>
            </div>
            <Alert
                type="info"
                showIcon
                message="Modification directe désactivée"
                description="Le grand livre des mouvements est en mode append-only. Pour corriger le stock d'une variante, créez un ajustement positif ou négatif depuis la page de réconciliation des stocks."
                style={{ marginBottom: 16 }}
            />
            <Button
                type="primary"
                onClick={handleGoToReconciliation}
                style={{ width: '100%', borderRadius: 5 }}
            >
                Aller à la réconciliation des stocks
            </Button>
        </Card>
    );
};

export default VarianteEdit;
